import React from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import config from '../config.js'

import {fetchDataIfReady} from 'Skelet/src/modules/fetch.action.js'
import {handleChange} from 'Skelet/src/modules/functions.js'
import ModalWrapper from 'Skelet/src/components/Modal_Wrapper.js'


class ModalCreateSizes extends React.Component {

  constructor(props) {
    super(props);

    let now = new Date();
    let date = now.getFullYear()+"-"+('0'+(now.getMonth()+1)).slice(-2)+"-"+('0'+now.getDate()).slice(-2);
    this.state = {weight:"", date, today:date};
  }

  render() {
    if(this.props.shouldShow) {
      const {date} = this.state;
      const valid_date = Date.parse(this.state.date) <= Date.parse(this.state.today);
      const submit_disabled = this.state.weight.trim() === "" || this.state.date.trim() === "" || !valid_date;

      let unique_date = true;
      if(date.trim() !== "") {
        let sizes = this.props.apiData["sizes_list"];
        if(sizes !== undefined && !sizes.isFetching && sizes.data !== [] && sizes.data[0]) {
          let found_date = sizes.data.find(function(size) {
            return size.date === date;
          });
          if(found_date) unique_date = false;
        }
      }

      return (
        <ModalWrapper switchState={this.props.close}>
          <form onSubmit={(e) => {e.preventDefault();this.submitForm()}}>
            <div><input type="text" value={this.state.weight} onChange={(e) => handleChange(this, "weight", e)} maxLength="7" placeholder="Gewicht" autoFocus /></div>
            <div><input type="date" value={this.state.date} onChange={(e) => handleChange(this, "date", e)} maxLength="10" placeholder="JJJJ-MM-DD" /></div>
            {!valid_date && <div><small>Ongeldige datum, vul een datum in van vandaag of eerder.</small></div>}
            {!unique_date && <div><small>Ongeldige datum, vul maximaal één meting per dag in. Wil je een meting wijzigen? Verwijder deze eerst via de knop "metingen beheren".</small></div>}
            <div><input type="submit" value="toevoegen" disabled={submit_disabled} /></div>
          </form>
        </ModalWrapper>
      );
    } else {
      return null;
    }
  }

  submitForm() {
    const {weight, date} = this.state;
    const submit_disabled = weight.trim() === "" || date.trim() === "";
    if(!submit_disabled) {
      let weight_float = parseFloat(weight.toString().replace(",", "."));
      if(!isNaN(weight_float)) {
        this.props.fetchDataIfReady(config.api_token, "bin", "POST", config.api_url+"/sizes", JSON.stringify({session_token:this.props.session_token, weight:weight_float, date}), null, true, false, true, false, false, null, "sizes_list");
        this.props.close();
        this.setState({weight:"", date:""});
      }
    }
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalCreateSizes)



// WEBPACK FOOTER //
// ./src/containers/ModalCreateSizes.js